// Ustawienia instancji, które zmienia administrator spółdzielni przez PUT /settings/.
// Fakturowanie, KSeF oraz włącznik i model bilansowania ustawia operator — admin dostałby 422.
import { validateNumberFormat } from './invoiceNumbering';
import { normalizeAmount, validateAmount } from './balancing';

// Jak spółdzielnia fakturuje gminę (JST) i jej jednostki; każde PPE ma zawsze własny wiersz i saldo
export const INVOICE_GROUPING_OPTIONS = [
    {
        value: 'jst',
        label: 'Jedna na JST, wiersz na każde PPE',
        description: 'Jedna faktura na całą gminę razem z jednostkami. Jednostki nie ma na fakturze, więc w KSeF widzi ją tylko gmina; '
            + 'jednostkę widać w opisie wiersza PPE.',
    },
    {
        value: 'unit',
        label: 'Jedna na jednostkę, wiersz na każde PPE (domyślna)',
        description: 'Osobna faktura dla każdej jednostki, z jednostką jako podmiotem trzecim. '
            + 'PPE samej gminy trafiają na fakturę gminy bez podmiotu trzeciego.',
    },
    {
        value: 'ppe',
        label: 'Jedna na każde PPE',
        description: 'Osobna faktura na każde PPE, z jednostką jako podmiotem trzecim. Dotyczy wszystkich członków: '
            + 'firma z trzema PPE dostaje trzy faktury.',
    },
];

export const invoiceGroupingLabel = (value) =>
    INVOICE_GROUPING_OPTIONS.find((option) => option.value === value)?.label || value;

export const settingsFormFor = (settings) => ({
    groupingUserPaysToCoop: settings.invoice_grouping_user_pays_to_coop || 'unit',
    groupingCoopPaysToUser: settings.invoice_grouping_coop_pays_to_user || 'unit',
    rate: settings.balancing_rate_per_mwh ?? '',
    numberFormat: settings.balancing_invoice_number_format || '',
});

// Zmienione pola do PUT /settings/ (pominięte backend zostawia bez zmian) i błędy walidacji per pole
export const settingsChanges = (settings, form) => {
    const changes = {};
    const errors = {};

    if (form.groupingUserPaysToCoop !== settings.invoice_grouping_user_pays_to_coop) {
        changes.invoice_grouping_user_pays_to_coop = form.groupingUserPaysToCoop;
    }
    if (form.groupingCoopPaysToUser !== settings.invoice_grouping_coop_pays_to_user) {
        changes.invoice_grouping_coop_pays_to_user = form.groupingCoopPaysToUser;
    }

    // Stawkę da się zmienić, ale nie wyczyścić — bez niej model stałej stawki nic nie fakturuje.
    // W modelu ZSE stawka nie jest używana, więc nie ma czego wysyłać.
    if (settings.balancing_model === 'fixed_rate') {
        const currentRate = settings.balancing_rate_per_mwh ?? '';
        const rateText = normalizeAmount(form.rate);
        if (rateText !== '' || currentRate !== '') {
            const rateError = validateAmount(rateText, 'Stawka');
            if (rateError) {
                errors.rate = rateError;
            } else if (currentRate === '' || Number(rateText) !== Number(currentRate)) {
                changes.balancing_rate_per_mwh = rateText;
            }
        }
    }

    const formatText = String(form.numberFormat ?? '').trim();
    const formatError = formatText
        ? validateNumberFormat(formatText)
        : 'Format numeru faktury za bilansowanie jest wymagany';
    if (formatError) {
        errors.numberFormat = formatError;
    } else if (formatText !== settings.balancing_invoice_number_format) {
        changes.balancing_invoice_number_format = formatText;
    }

    return { changes, errors };
};
